var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [(_vm.danger) ? _c('div', {
    class: _vm.theme.stepDanger
  }, [_c('v-font-icon', {
    attrs: {
      "danger": ""
    }
  }, [_vm._v("\n            warning\n        ")])], 1) : _c('div', {
    class: _vm.theme.stepCircle
  }, [(_vm.isComplete) ? _c('v-font-icon', {
    class: _vm.theme.stepCircleDone,
    attrs: {
      "white": ""
    }
  }, [_vm._v("done")]) : _c('span', [_vm._v(_vm._s(_vm.step))])], 1), _vm._v(" "), _c('div', {
    class: _vm.theme.stepLabel
  }, [_vm._t("default", [_c('div', [_c('v-text', {
    attrs: {
      "type": "subheadling"
    }
  }, [_vm._v("Lorem Ipsum")])], 1), _vm._v(" "), _c('v-text', {
    attrs: {
      "caption": ""
    }
  }, [_vm._v("Lorem Ipsum")])])], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c1cae43","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Stepper/StepperLabel.vue
// module id = 664
// module chunks = 0